import {Component, Input, OnInit} from '@angular/core';
import {Application} from "../../model/app.model";
import {CommonService} from "../../service/common.service";

@Component({
  selector: 'app-application-item',
  templateUrl: './application-item.component.html',
  styleUrls: ['./application-item.component.scss'],
})
export class ApplicationItemComponent  implements OnInit {

  @Input() application: Application;

  constructor(public commonService: CommonService) { }

  ngOnInit() {}

  onSelectChange(){
    this.commonService.openDownloadLink(this.application.androidAppId, this.application.iosAppId);
  }

}
